import { Modal, Spin } from "antd";
import styles from "./styles.module.scss";
import { ReminderHistoryTable } from "pages/cases-detail/components/case-reminder/reminderHistoryTable";
import {
  UseApiCall,
  UseApiCallV2,
  UseLazyApiCall,
  UseLazyApiCallV2,
} from "hooks";
import { UseGetCurrentUser } from "hooks/use-get-current-user";
import { useCurrentUserContext } from "providers";
import { useEffect, useMemo, useState } from "react";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const AllReminders = ({ data, open, handleCloseModal, employees }) => {
  const { translator } = useLanguageTranslator();

  const finalEmployees = useMemo(() => {
    return employees?.users?.map((item) => {
      return {
        label: item?.username,
        value: item?.email,
      };
    });
  }, [employees?.users]);

  const { user } = useCurrentUserContext();
  const [reminders, setReminders] = useState([]);

  const [filtersData, setFiltersData] = useState({
    dueDate: null,
    createdBy: null,
    category: null,
    assignedTo: user?.email,
    // status: null,
  });

  const [
    get_email_reminders,
    {
      data: reminderHistory,
      isLoading: reminderHistoryLoading,
      refetch: refetchReminderHistory,
    },
  ] = UseLazyApiCallV2({
    url: "/get_user_reminders",
    method: "POST",
    paramsData: {
      loggedUser: user?.email,
    },
  });

  useEffect(() => {
    if (user?.email && open) {
      fetchEmailReminders();
    }
  }, [user?.email, open]);

  async function fetchEmailReminders() {
    const filters = {
      ...filtersData,
      dueDate: filtersData.dueDate
        ? filtersData.dueDate.replaceAll(".", "-")
        : null,
    };

    try {
      const res = await get_email_reminders({
        params: {
          email: user?.email,
          filters,
        },
      });
      setReminders(res?.reminders || []);
    } catch (error) {
      console.log({
        error,
      });
    }
  }

  return (
    <Modal
      destroyOnClose
      title={
        <h3 style={{ marginTop: "20px" }}>
          {translator("pendingReminders").pendingReminders}
        </h3>
      }
      open={open}
      onCancel={handleCloseModal}
      footer={null}
      centered
      width="97dvw"
      styles={{
        content: {
          backgroundColor: "#F5F6F8",
          height: "97dvh",
        },
        header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
      }}
    >
      <ReminderHistoryTable
        employees={finalEmployees}
        reminders={reminders}
        isLoading={false}
        height={`calc(87dvh - 90px)`}
        minHeight={`calc(92dvh - 90px)`}
        filtersData={filtersData}
        setFiltersData={setFiltersData}
        refetchReminderHistory={fetchEmailReminders}
        variant="pending"
      />
    </Modal>
  );
};
